export default "__VITE_ASSET__BzfGT3YK__"